import { render, staticRenderFns } from "./DevolucionGenerarNC.vue?vue&type=template&id=e2f6d706&scoped=true"
import script from "./DevolucionGenerarNC.vue?vue&type=script&lang=js"
export * from "./DevolucionGenerarNC.vue?vue&type=script&lang=js"
import style0 from "./DevolucionGenerarNC.vue?vue&type=style&index=0&id=e2f6d706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f6d706",
  null
  
)

export default component.exports